import { render, staticRenderFns } from "./others.vue?vue&type=template&id=2d25759c&scoped=true&"
import script from "./others.vue?vue&type=script&lang=js&"
export * from "./others.vue?vue&type=script&lang=js&"
import style0 from "./others.vue?vue&type=style&index=0&id=2d25759c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d25759c",
  null
  
)

export default component.exports